<template>
  <article class="news-article" v-if="news_item && news_item.title">
    <div
      v-if="news_item.imageUrl"
      class="news-article__cover"
    >
      <NewsCropImageView
        :image-url="news_item.imageUrl"
        :crop-zoom="news_item.imageCropZoom"
        :crop-pan-x="news_item.imageCropPanX"
        :crop-pan-y="news_item.imageCropPanY"
        :alt="news_item.title"
      />
    </div>

    <header class="news-article__header">
      <h1 class="news-article__title text-TTDrugs-Bold-40">{{ news_item.title }}</h1>
      <p v-if="formattedDate" class="news-article__date text-circe-16 color-gray">
        {{ formattedDate }}
      </p>
    </header>

    <div
      v-if="useConstructorBlocks"
      class="news-article__blocks"
    >
      <component
        v-for="(block, index) in articleBlocks"
        :key="block.id || ('news-block-' + index)"
        :is="getBlockComponent(block.type)"
        :data="normalizeBlockData(block)"
        :class="getBlockClass(block)"
      />
    </div>

    <div
      v-else-if="content"
      class="news-article__body ql-editor"
      v-html="content"
    />

    <p
      v-else
      class="news-article__empty"
      role="status"
    >
      Текст новости пока не заполнен.
    </p>
  </article>
</template>

<script>
import NewsCropImageView from '@/components/News/NewsCropImageView.vue'
import AppEditorBlock from '@/components/Blocks/AppEditorBlock.vue'
import AppHtmlContentBlock from '@/components/Blocks/AppHtmlContentBlock.vue'
import AppImageBlock from '@/components/Blocks/AppImageBlock.vue'
import AppImageTextBlock from '@/components/Blocks/AppImageTextBlock.vue'
import AppCarouselBlock from '@/components/Blocks/AppCarouselBlock.vue'

const NEWS_BLOCK_COMPONENTS = {
  editor: 'AppEditorBlock',
  html_content: 'AppHtmlContentBlock',
  image: 'AppImageBlock',
  image_text: 'AppImageTextBlock',
  carousel: 'AppCarouselBlock',
}

export default {
  name: 'AppSectionNewsDetails',
  components: {
    NewsCropImageView,
    AppEditorBlock,
    AppHtmlContentBlock,
    AppImageBlock,
    AppImageTextBlock,
    AppCarouselBlock,
  },
  props: {
    news_item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    content() {
      return this.news_item && this.news_item.content
        ? this.news_item.content
        : ''
    },
    articleBlocks() {
      const blocks = this.news_item && Array.isArray(this.news_item.blocks)
        ? this.news_item.blocks
        : []
      return blocks
        .filter((b) => b && b.type)
        .slice()
        .sort((a, b) => (a.order || 0) - (b.order || 0))
    },
    useConstructorBlocks() {
      const mode = this.news_item && this.news_item.editorMode
      return mode === 'constructor' && this.articleBlocks.length > 0
    },
    formattedDate() {
      const raw = this.news_item && this.news_item.dateTime
      if (!raw) return ''

      const date = new Date(raw)
      if (Number.isNaN(date.getTime())) return String(raw)

      return date.toLocaleDateString('ru-RU', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
      })
    },
  },
  methods: {
    getBlockComponent(blockType) {
      return NEWS_BLOCK_COMPONENTS[blockType] || 'AppHtmlContentBlock'
    },
    normalizeBlockData(block) {
      const data = { ...((block && block.data) || {}) }
      // editor / html: канон — content; html из ранних тестов тоже читаем
      if ((block.type === 'editor' || block.type === 'html_content') && !data.content && data.html) {
        data.content = data.html
      }
      return data
    },
    getBlockClass(block) {
      const type = block.type || 'unknown'
      const classes = [`news-article__block`, `news-article__block--${type}`]
      if (type === 'image') {
        const layout = String((block.data && (block.data.layout || block.data.width)) || 'inset').toLowerCase()
        classes.push(layout === 'wide' ? 'news-article__block--wide' : 'news-article__block--inset')
      }
      if (type === 'carousel') {
        classes.push('news-article__block--wide')
      }
      return classes
    },
  },
}
</script>
